<template>
    <form method="POST" :action="route">
        <input type="hidden" name="_token" :value="token">
            <table class="myfotable-dark" style="border-collapse: collapse;">
                <colgroup>
                    <col style="width: 25%;">
                    <col style="width: 25%;">
                    <col style="width: 25%;">
                    <col style="width: 25%;">
                </colgroup>
                <thead>
                    <tr style="border-right: 1px solid rgba(255, 255, 255, 0.6); border-left: 1px solid rgba(255, 255, 255, 0.6);">
                        <th scope="col" style="">Plateforme</th>
                        <th scope="col" style="">Contrat</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(investment, index) in invs" :key="index" style="border-right: 1px solid rgba(255, 255, 255, 0.6); border-left: 1px solid rgba(255, 255, 255, 0.6);">
                        <input type="hidden"
                            :name="'form[' + index + '][id]'"
                            :value="investment.id ">
                        <td style="">
                            <select
                                class="form-control-4"
                                v-model="investment.intermediary"
                                :disabled="investment.id != null"
                                @change="onIntermediaryChange(investment)">
                                <option value="" disabled>Plateforme</option>
                                <option v-for="intermediary in interms" :key="intermediary.id" :value="intermediary" >{{ intermediary.name }}</option>
                            </select>
                            <input type="hidden"
                                :name="'form[' + index + '][intermediary_id]'"
                                :value="investment.intermediary.id ">
                        </td>
                        <td v-if="investment.intermediary.multi_broker == 1" style="">
                            <select
                                class="form-control-4"
                                v-model="investment.platform"
                                :disabled="investment.id != null">
                                <option value="" disabled>Contrat</option>
                                <option v-for="platform in investment.intermediary.platform" :key="platform.id" :value="platform">{{ platform.name }}</option>
                                <!-- <option v-for="platform in filteredPlatforms(investment)" :key="platform.id" :value="platform">{{ platform.name }}</option> -->
                            </select>
                            <input type="hidden"
                                :name="'form[' + index + '][platform_id]'"
                                :value="investment.intermediary.platform[0].id ">
                        </td>
                        <td v-else-if="investment.intermediary.has_branch == 1" style="">
                            <select
                                class="form-control-4"
                                v-model="investment.branch"
                                :disabled="investment.id != null">
                                <option value="" disabled>Branch</option>
                                <option v-for="branch, in investment.intermediary.branchs"
                                    :key="branch.id"
                                    :value="branch">
                                    {{ branch.name }}
                                </option>
                                <!-- <option v-for="platform in filteredPlatforms(investment)" :key="platform.id" :value="platform">{{ platform.name }}</option> -->
                            </select>
                            <input
                                type="hidden"
                                :name="'form[' + index + '][branch_id]'"
                                :value="investment.branch.id ">
                        </td>
                        <td v-else style="">
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="m-4 justify-content-center text-center">
                <button type="submit" class="btn-alt-2 m-2 triggerspinner-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-clockwise mr-1" viewBox="0 0 16 16">
                        <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                        <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                    </svg>
                    Trouvez les meilleurs investissements climatiques!
                </button>
            </div>

    </form>
</template>

<script>
    export default {
        props: [
            'intermediaries',
            'platforms',
            'branchs',
            'token',
            'route',
        ],

        data() {
            return {
                form: [],
                invs:[],
                interms:[],
                plats:[],
                bras:[],
                valid: false,
            }
        },

        mounted() {

            this.intermediaries.forEach(intermediary =>
            {
                this.interms.push(intermediary);
            });
            this.platforms.forEach(platform =>
            {
                this.plats.push(platform);
            });
            this.branchs.forEach(branch =>
            {
                this.bras.push(branch);
            });

            this.invs.forEach(investment =>
            {
                investment.intermediary = this.interms.find(intermediary => investment.intermediary.id === intermediary.id)              ;
            });

            this.addRaw();


        },
        methods: {

            onIntermediaryChange(investment){
                investment.intermediary.platform = this.plats.filter(platform => platform.intermediary_id === investment.intermediary.id);
                investment.platform = investment.intermediary.platform[0];

                if (investment.intermediary.has_branch == 1)
                {
                    investment.branch = investment.intermediary.branchs[0];
                }
            },

            addRaw(){
                this.invs.push(
                {
                    id: null,
                    intermediary: this.intermediaries[0],
                    platform: this.platforms[0],
                });
        },
    }
}


</script>